// extracted by mini-css-extract-plugin
export default {"r_l":"_1a69636eab ff51e567e7","t":"c01e4291c6"};